var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareLogo64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5583C0 6.79412 6.29412 0.5 14.0583 0.5H49.9417C57.7059 0.5 64 6.79412 64 14.5583V50.4417C64 58.2059 57.7059 64.5 49.9417 64.5H14.0583C6.29412 64.5 0 58.2059 0 50.4417V14.5583ZM49.165 51.4514L36.2133 32.3049L48.4692 14.3252H39.5315L31.9852 25.9404L24.4925 14.3252H15.6083L27.8107 32.3579L14.9126 51.4514H23.8503L31.9852 38.7224L40.1737 51.4514H49.165Z",
    fill: "#001B42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo64);
export default __webpack_public_path__ + "static/media/square-logo-64.f60061a321714476a39a5d94332f27e0.svg";
export { ForwardRef as ReactComponent };